export default __webpack_public_path__ + "static/media/12380 - Obolazul.5979fb7a.jpeg";